<template>
    <div class="flex space-x-2" v-tooltip.bottom="{ content: 'Reset margins' }">
        <div @click="builderStyle.resetMargins" :class="[
          'w-6 h-6 won-tag-light-gray rounded-md',
          'cursor-pointer flex items-center justify-center select-none',
        ]" >
        <svg class="won-color-gray stroke-2 w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_25898)">
            <path d="M10.0002 4.16671V0.833374L5.8335 5.00004L10.0002 9.16671V5.83337C12.7585 5.83337 15.0002 8.07504 15.0002 10.8334C15.0002 13.5917 12.7585 15.8334 10.0002 15.8334C7.24183 15.8334 5.00016 13.5917 5.00016 10.8334H3.3335C3.3335 14.5167 6.31683 17.5 10.0002 17.5C13.6835 17.5 16.6668 14.5167 16.6668 10.8334C16.6668 7.15004 13.6835 4.16671 10.0002 4.16671Z" fill="#444C58"/>
            </g>
            <defs>
            <clipPath id="clip0_1_25898">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
            </svg>
        </div>
    </div>
</template>
  
<script setup>
import { useBuilderStyles } from '../../store/builder-style.store'
const builderStyle = useBuilderStyles()
</script>
